module.exports = __webpack_public_path__ + "media/images/admin/image-placeholder-85841ea0d6233f41814c840a7aa0b536.png";